import type { ZudokuConfig } from "zudoku";
import posthogPlugin from "./plugins/posthog";
import LlmActions from "./components/LlmActions";

const config: ZudokuConfig = {
  plugins: [posthogPlugin],
  slots: {
    "content-before": LlmActions,
  },
  // Disable search in development - Pagefind requires a build to generate the index
  // search: {
  //   type: "pagefind",
  // },
  theme: {
    defaultMode: "dark",
  },
  metadata: {
    favicon: "/favicon.ico",
  },
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Relay SMS Platform",
      width: "95px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            "/introduction",
            // Temporarily disabled due to MDX parsing issues - will re-enable after fixing JSX syntax
            // "/getting-started/quick-start",
            "/getting-started/installation",
            "/getting-started/development-setup",
          ],
        },
        {
          type: "category",
          label: "Core Concepts",
          icon: "lightbulb",
          items: [
            "/concepts/sms-basics",
            "/concepts/idempotency",
            "/concepts/webhook-security",
          ],
        },
      ],
    },
    {
      type: "category",
      label: "Autonomous Agents",
      icon: "bot",
      items: [
        "/agents/index",
        "/agents/quick-start",
        "/agents/trust-levels",
        "/agents/integration",
      ],
    },
    {
      type: "category",
      label: "SMS Templates",
      icon: "message-square",
      items: [
        "/sms-templates/index",
        {
          type: "category",
          label: "Installation",
          items: [
            "/sms-templates/installation/quick-start",
            "/sms-templates/installation/sending-templates",
          ],
        },
        {
          type: "category",
          label: "Available Templates",
          items: [
            "/sms-templates/available-templates/authentication-templates",
            "/sms-templates/available-templates/transaction-templates",
            "/sms-templates/available-templates/appointment-templates",
          ],
        },
        {
          type: "category",
          label: "Template Features",
          items: [
            "/sms-templates/template-features/validation",
            "/sms-templates/template-features/template-discovery",
            "/sms-templates/template-features/character-counting",
            "/sms-templates/template-features/compliance-features",
            "/sms-templates/template-features/typescript-support",
          ],
        },
        {
          type: "category",
          label: "Best Practices",
          items: [
            "/sms-templates/best-practices/keep-company-names-short",
            "/sms-templates/best-practices/use-consistent-formatting",
            "/sms-templates/best-practices/test-before-sending",
            "/sms-templates/best-practices/handle-errors-gracefully",
            "/sms-templates/best-practices/url-shortening",
          ],
        },
        "/sms-templates/custom-templates",
      ],
    },
    {
      type: "category",
      label: "API Reference",
      icon: "code",
      items: [
        {
          type: "link",
          label: "Endpoints",
          to: "/api",
        },
        "/api-reference/errors",
        "/api-reference/changelog",
        "/api-reference/versioning",
      ],
    },
  ],
  redirects: [
    { from: "/", to: "/introduction" },
    { from: "/guides/using-templates", to: "/sms-templates/index" },
    // Old hand-written API reference pages now redirect to the OpenAPI explorer
    { from: "/api-reference", to: "/api" },
    { from: "/api-reference/index", to: "/api" },
    { from: "/api-reference/authentication", to: "/api" },
    { from: "/api-reference/messages", to: "/api" },
    { from: "/api-reference/phone-numbers", to: "/api" },
    { from: "/api-reference/webhooks", to: "/api" },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.yaml",
      path: "/api",
      disablePlayground: true,
    },
  ],
};

export default config;
